import React, { useState, useRef, useEffect } from "react";
import {
  Button,
  Row,
  Col,
  Space,
  Form,
  Input,
  DatePicker,
  Select,
  Table,
  notification,
  Spin,
  message
} from "antd";
import { format } from 'date-fns';
import {
  SearchOutlined,
} from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { saveAs } from "file-saver";

import moment from "moment";
import util from "helpers/util";
import CModal from "./CModal";
import apiStockAdjustment from "constants/api/stockAdjustment";

export default function AdjustStatus() {
  const dateFormat = "YYYY-MM-DD";
  const { RangePicker } = DatePicker;

  const [formTakeList] = Form.useForm();

  const [isLoadingTbAdjustStatus, setisLoadingTbAdjustStatus] = useState(false);
  const [rowsAdjustStatusList, setRowsAdjustStatus] = useState([]);
  const [tbUSListSearchText, setTbStockTakeListSearchText] = useState("");
  const [tbUSListSearchedColumn, setTbStockTakeListSearchedColumn] = useState("");

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [dataModal, setDataModal] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const tbStockTakeListSearchInput = useRef(null);
  const urlDetail = util.getCurrentUrlDetail();
  const decodePath = decodeURIComponent(urlDetail.subPath ?? "");

  const [dates, setDates] = useState(null);
  const [value, setValue] = useState(null);
  const [limitDays, setLimitDays] = useState(0);

  useEffect(() => {
    if (decodePath == "submitted") {
      setisLoadingTbAdjustStatus(true);
      const startOfMonth = moment().startOf('month').format('YYYY-MM-DD');
      const endOfMonth = moment().endOf('month').format('YYYY-MM-DD');
      apiStockAdjustment
        .getAdjustmentList(startOfMonth, endOfMonth)
        .then((res) => {
          if (res.success) {
            let newRows = [];
            if (res.success) {
              res.result.sort(function (a, b) {
                return moment(b.creationTime).unix() - moment(a.creationTime).unix();
              });
              res.result.map((row, index) => {
                newRows.push({
                  index: index + 1,
                  key: row.id,
                  draftNumber: row.draftNumber,
                  adjustmentNumber: row.adjustmentNumber,
                  store: row.store,
                  creatorUser: row.creatorUser,
                  creationTime: util.formatNullableDatetime(row.creationTime)
                });
              });
              setRowsAdjustStatus(newRows);
            }

            setisLoadingTbAdjustStatus(false);
          }
          else {
            notification.error({
              message: "Error",
              description: res.message,
              duration: 0,
            });

            setisLoadingTbAdjustStatus(false);
          }
        })
        .catch((err) => {
          notification.error({
            message: "Internal server error. please contact administrator",
            duration: 0,
          });
          setisLoadingTbAdjustStatus(false);
        })
        .finally(() => {
          setisLoadingTbAdjustStatus(false);
        });
    }
  }, [])

  useEffect(() => {
    apiStockAdjustment.getLimitFetchDays()
      .then((res) => {
        if (res.success) {
          setLimitDays(res.result);
        }
        else {
          message.error("Cannot get limit days");
        }
      })
      .catch((err) => {
        message.error("Cannot get limit days");
      })
  }, []);

  const disabledDate = (current) => {
    if (!dates) {
      return false;
    }
    const tooLate = dates[0] && current.diff(dates[0], 'days') >= limitDays;
    const tooEarly = dates[1] && dates[1].diff(current, 'days') >= limitDays;
    return !!tooEarly || !!tooLate;
  };

  const onOpenChange = (open) => {
    if (open) {
      setDates([null, null]);
    } else {
      setDates(null);
    }
  };

  const downloadLPN = (adjustmentNumber) => {
    setIsLoading(true);
    apiStockAdjustment
      .getLPNFile(adjustmentNumber)
      .then((res) => {
        const date = format(new Date(), 'yyyyMMdd');
        const filename = `LPN_StockAdjustment_${adjustmentNumber}_${date}`;
        var blob = new Blob([res.data], {
          type:
            "application/pdf",
        });
        let url = window.URL.createObjectURL(blob);
        saveAs(url, filename);
        setIsLoading(false);
      })
      .catch((err) => {
        util.displayApiError(err);
        setIsLoading(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  const downloadPackageList = (adjustmentNumber) => {
    setIsLoading(true);
    apiStockAdjustment
      .getPackingListFile(adjustmentNumber)
      .then((res) => {
        const date = format(new Date(), 'yyyyMMdd');
        const filename = `PackageList_StockAdjustment_${adjustmentNumber}_${date}`;
        var blob = new Blob([res.data], {
          type:
            "application/pdf",
        });
        let url = window.URL.createObjectURL(blob);
        saveAs(url, filename);
        setIsLoading(false);
      })
      .catch((err) => {
        util.displayApiError(err);
        setIsLoading(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  const tbStockTakeListHandleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setTbStockTakeListSearchText(selectedKeys[0]);
    setTbStockTakeListSearchedColumn(dataIndex);
  };

  const tbStockTakeListHandleReset = (clearFilters) => {
    clearFilters();
    setTbStockTakeListSearchText("");
  };

  const onCloseCModal = () => {
    setIsModalVisible(false);
    setDataModal({});
  };


  const showCModal = (adjustmentNumber) => {
    setIsLoading(true);

    apiStockAdjustment
      .getAdjustmentDetail(adjustmentNumber)
      .then((res) => {
        setDataModal(res.result);
        setIsModalVisible(true);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  const onActionDropDownChange = (selectedDropDown) => {
    if (selectedDropDown.label === "Detail") {
      let data = selectedDropDown.value.split("|")
      showCModal(data[1]);
    }
    if (selectedDropDown.label === "Download LPN") {
      let data = selectedDropDown.value.split("|")
      downloadLPN(data[1]);
    }
    if (selectedDropDown.label === "Download Packing List") {
      let data = selectedDropDown.value.split("|")
      downloadPackageList(data[1]);
    }
  };

  const onFinishFormAdjustStatus = (values) => {
    setisLoadingTbAdjustStatus(true);

    const dataToSubmit = {
      startTime: values.creationTime == null || values.creationTime[0] == null
        ? ""
        : values.creationTime[0].format(dateFormat),
      endTime: values.creationTime == null || values.creationTime[1] == null
        ? ""
        : values.creationTime[1].format(dateFormat),
    };

    // if (dataToSubmit.startTime == "" || dataToSubmit.endTime == "") {
    //   notification.error({
    //     message: "Error",
    //     description: "Creation date cannot be empty",
    //     duration: 0,
    //   });

    //   setisLoadingTbAdjustStatus(false);

    //   return;
    // }
    //calculate difference days, with today (+ 1)
    if (dataToSubmit.startTime != '') {
      const dateDiff = values.creationTime[1].diff(values.creationTime[0], 'days') + 1;

      if (dateDiff > limitDays) {
        notification.error({
          message: "Error",
          description: `Creation date range must ${limitDays} days`,
          duration: 0,
        });

        setisLoadingTbAdjustStatus(false);

        return;
      }
    }

    apiStockAdjustment
      .getAdjustmentList(dataToSubmit.startTime, dataToSubmit.endTime)
      .then((res) => {
        if (res.success) {
          let newRows = [];
          if (res.success) {
            res.result.sort(function (a, b) {
              return moment(b.creationTime).unix() - moment(a.creationTime).unix();
            });
            res.result.map((row, index) => {
              newRows.push({
                index: index + 1,
                key: row.id,
                draftNumber: row.draftNumber,
                adjustmentNumber: row.adjustmentNumber,
                store: row.store,
                creatorUser: row.creatorUser,
                creationTime: util.formatNullableDatetime(row.creationTime)
              });
            });
            setRowsAdjustStatus(newRows);
          }

          setisLoadingTbAdjustStatus(false);
        }
        else {
          notification.error({
            message: "Error",
            description: res.message,
            duration: 0,
          });

          setisLoadingTbAdjustStatus(false);
        }
      })
      .catch((err) => {
        notification.error({
          message: "Internal server error. please contact administrator",
          duration: 0,
        });
        setisLoadingTbAdjustStatus(false);
      })
      .finally(() => {
        setisLoadingTbAdjustStatus(false);
      });
  };

  const onFinishFailedFormAdjustStatus = (errorInfo) => {
    notification.error({
      message: "Failed to get data",
      duration: 0,
    });
  };



  const tbTakeListGetColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={tbStockTakeListSearchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            tbStockTakeListHandleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              tbStockTakeListHandleSearch(selectedKeys, confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => tbStockTakeListHandleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setTbStockTakeListSearchText(selectedKeys[0]);
              setTbStockTakeListSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : "",
    render: (text) =>
      tbUSListSearchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[tbUSListSearchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columnsAdjustStatusList = [
    {
      title: "#",
      dataIndex: "index",
      width: 40,
      align: "center",
      sorter: (a, b) => a.index - b.index,
    },
    {
      title: "Draft Number",
      dataIndex: "draftNumber",
      ...tbTakeListGetColumnSearchProps("draftNumber"),
      sorter: (a, b) => a.draftNumber.localeCompare(b.draftNumber),
    },
    {
      title: "Adjust Number",
      dataIndex: "adjustmentNumber",
      ...tbTakeListGetColumnSearchProps("adjustmentNumber"),
      sorter: (a, b) => a.adjustmentNumber.localeCompare(b.adjustmentNumber),
    },
    {
      title: "Store",
      dataIndex: "store",
      ...tbTakeListGetColumnSearchProps("store"),
      sorter: (a, b) => a.store - b.store,
    },
    {
      title: "Creator User",
      dataIndex: "creatorUser",
      ...tbTakeListGetColumnSearchProps("creatorUser"),
      sorter: (a, b) => a.token.localeCompare(b.creatorUser),
    },
    {
      title: "Creation Date",
      dataIndex: "creationTime",
      ...tbTakeListGetColumnSearchProps("creationTime"),
      sorter: (a, b) => moment(a.creationTime).unix() - moment(b.creationTime).unix(),
    },
    {
      title: "Action",
      render: (_, record) => (
        <Select
          labelInValue
          style={{ width: "100%" }}
          defaultValue={{ label: "Action", value: "default-selected" }}
          onChange={(selectedDropDown) => onActionDropDownChange(selectedDropDown)}
          value={{ label: "Action", value: "default-selected" }}
          options={[
            {
              value: 'D|' + record.adjustmentNumber,
              label: 'Detail',
            },
            {
              value: 'L|' + record.adjustmentNumber,
              label: 'Download LPN'
            },
            {
              value: 'P|' + record.adjustmentNumber,
              label: 'Download Packing List'
            },
            {
              value: '',
              label: 'Action',
              disabled: true,
              hidden: true
            },
          ]}
        >
          {/* <Option label="detail" value={record.key}>Detail</Option>
          <Option label="result" value={record.key}>Result</Option>
          <Option label="action" value="default-selected" disabled hidden>Action</Option> */}
        </Select>
      ),
    }
  ];

  return (
    <>
      <CModal
        visible={isModalVisible}
        onClose={onCloseCModal}
        onCancel={() => setIsModalVisible(false)}
        dataModal={dataModal}
      />
      <Spin tip="Loading..." size="large" spinning={isLoading}>
        <Row>
          <Col span={24}>
            <Form
              layout="vertical"
              form={formTakeList}
              onFinish={onFinishFormAdjustStatus}
              initialValues={{
                creationDate: null
              }}
              onFinishFailed={onFinishFailedFormAdjustStatus}
            >
              <Row gutter={10} align="bottom">
                <Col span={4}>
                  <Form.Item label="Creation Date" name="creationTime">
                    <RangePicker
                      style={{ width: "100%" }}
                      value={dates || value}
                      disabledDate={disabledDate}
                      onCalendarChange={(val) => {
                        setDates(val);
                      }}
                      onChange={(val) => {
                        setValue(val);
                      }}
                      onOpenChange={onOpenChange}
                      changeOnBlur
                    />
                  </Form.Item>
                </Col>
                <Col span={2}>
                  <Form.Item>
                    <Button block type="primary" htmlType="submit">
                      Fetch
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
              <Row justify="end" gutter={15}></Row>
            </Form>
          </Col>
        </Row>
        <Row>
          <Col>
          </Col>
        </Row>
        <br />
        <Row>
          <Col span={24}>
            <Table
              size="small"
              loading={isLoadingTbAdjustStatus}
              columns={columnsAdjustStatusList}
              dataSource={rowsAdjustStatusList}
              pagination={{ pageSize: 5 }}
              bordered
            />
          </Col>
        </Row>
      </Spin>
    </>
  );
}
